import { useEffect, useState } from "react";
import axios from "axios";
import APS_URL from "../utils/APS_URL";

export function useInsightwinMachineMaster(group_code, project_code) {
  const [machineMasterData, setMachineMasterData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          APS_URL +
            `/api/mch/getAllMachine?group_code=${group_code}&project_code=${project_code}`
        );
        setMachineMasterData(res.data);
      } catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, []);
  return {
    machineMasterData,
  };
}
